import React, { useEffect, useState } from "react";
import { api } from "../lib/apiClient";
import { PageHero } from "../components/Shared";
import { VideoDialog } from "../components/VideoDialog";
import { Play } from "lucide-react";

export default function Videos() {
  const [videos, setVideos] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    api.get("/videos").then((r) => setVideos(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="videos-page">
      <PageHero
        label="Vidéos"
        title="La campagne en vidéo"
        subtitle="Nos prises de position et nos rencontres. Cliquez sur une vidéo pour la visionner."
      />

      <section className="max-w-7xl mx-auto px-5 sm:px-8 py-24">
        {videos.length === 0 ? (
          <p className="text-center text-[#4B5563]">Nos vidéos arrivent très bientôt.</p>
        ) : (
          <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
            {videos.map((v, i) => (
              <button
                key={v.id}
                onClick={() => setActive(v)}
                data-testid={`video-card-${i}`}
                className="group block text-left"
              >
                <div className="relative overflow-hidden rounded-2xl bg-[#12495B] shadow-[0_8px_30px_rgb(0,0,0,0.08)] aspect-[9/16]">
                  <img
                    src={v.thumbnail}
                    alt={v.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-[#12495B]/20 group-hover:bg-[#12495B]/35 transition-colors duration-300" />
                  <span className="absolute inset-0 flex items-center justify-center">
                    <span className="w-16 h-16 rounded-full bg-[#F5C518] text-[#12495B] flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
                      <Play size={28} fill="currentColor" className="ml-1" />
                    </span>
                  </span>
                  <span className="absolute top-4 left-4 text-[10px] tracking-[0.2em] uppercase font-extrabold bg-[#F5C518] text-[#12495B] px-3 py-1 rounded-full">
                    {v.category}
                  </span>
                </div>
                <h3 className="mt-4 font-display text-xl text-[#12495B] leading-snug group-hover:text-[#0E3B49] transition-colors duration-300">
                  {v.title}
                </h3>
                {v.subtitle && <p className="mt-1 text-sm text-[#4B5563]">{v.subtitle}</p>}
              </button>
            ))}
          </div>
        )}
      </section>

      <VideoDialog video={active} open={!!active} onOpenChange={(o) => !o && setActive(null)} />
    </div>
  );
}
